<div
  class="bm-header-btn-wrapper"
  [ngClass]="{ 'bm-header-btn-wrapper--wl-mode': wlMode }"
>
  <button
    class="bm-button bm-open-button"
    (click)="openPopup($event)"
    [ngClass]="{
      'bm-open-button--active': opened,
      'bm-open-button--text': !boxBtnMode,
      'bm-open-button--box': boxBtnMode
    }"
    *ngIf="activeEvents.length > 0 || redeemedEvents.length > 0"
  >
    <i>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          class="bm-open-button-svg-path"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.06666 12.0667C9.47167 12.0667 9.8 11.7383 9.8 11.3333C9.8 10.9283 9.47167 10.6 9.06666 10.6C8.66165 10.6 8.33333 10.9283 8.33333 11.3333C8.33333 11.7383 8.66165 12.0667 9.06666 12.0667ZM9.06666 14.6333C9.47167 14.6333 9.8 14.305 9.8 13.9C9.8 13.495 9.47167 13.1667 9.06666 13.1667C8.66165 13.1667 8.33333 13.495 8.33333 13.9C8.33333 14.305 8.66165 14.6333 9.06666 14.6333ZM9.8 16.4667C9.8 16.8717 9.47167 17.2 9.06666 17.2C8.66165 17.2 8.33333 16.8717 8.33333 16.4667C8.33333 16.0616 8.66165 15.7333 9.06666 15.7333C9.47167 15.7333 9.8 16.0616 9.8 16.4667ZM6.13334 14.6333C6.53835 14.6333 6.86668 14.305 6.86668 13.9C6.86668 13.495 6.53835 13.1667 6.13334 13.1667C5.72834 13.1667 5.40001 13.495 5.40001 13.9C5.40001 14.305 5.72834 14.6333 6.13334 14.6333ZM6.86668 16.4667C6.86668 16.8717 6.53835 17.2 6.13334 17.2C5.72834 17.2 5.40001 16.8717 5.40001 16.4667C5.40001 16.0616 5.72834 15.7333 6.13334 15.7333C6.53835 15.7333 6.86668 16.0616 6.86668 16.4667ZM12 12.0667C12.405 12.0667 12.7334 11.7383 12.7334 11.3333C12.7334 10.9283 12.405 10.6 12 10.6C11.595 10.6 11.2667 10.9283 11.2667 11.3333C11.2667 11.7383 11.595 12.0667 12 12.0667ZM12.7334 13.9C12.7334 14.305 12.405 14.6333 12 14.6333C11.595 14.6333 11.2667 14.305 11.2667 13.9C11.2667 13.495 11.595 13.1667 12 13.1667C12.405 13.1667 12.7334 13.495 12.7334 13.9ZM14.9333 15C15.5408 15 16.0333 14.5075 16.0333 13.9C16.0333 13.2925 15.5408 12.8 14.9333 12.8C14.3258 12.8 13.8333 13.2925 13.8333 13.9C13.8333 14.5075 14.3258 15 14.9333 15ZM12.7334 16.4667C12.7334 16.8717 12.405 17.2 12 17.2C11.595 17.2 11.2667 16.8717 11.2667 16.4667C11.2667 16.0616 11.595 15.7333 12 15.7333C12.405 15.7333 12.7334 16.0616 12.7334 16.4667ZM14.9333 12.0667C15.3384 12.0667 15.6667 11.7383 15.6667 11.3333C15.6667 10.9283 15.3384 10.6 14.9333 10.6C14.5283 10.6 14.2 10.9283 14.2 11.3333C14.2 11.7383 14.5283 12.0667 14.9333 12.0667ZM15.6667 16.4667C15.6667 16.8717 15.3384 17.2 14.9333 17.2C14.5283 17.2 14.2 16.8717 14.2 16.4667C14.2 16.0616 14.5283 15.7333 14.9333 15.7333C15.3384 15.7333 15.6667 16.0616 15.6667 16.4667ZM17.8667 12.0667C18.2717 12.0667 18.6 11.7383 18.6 11.3333C18.6 10.9283 18.2717 10.6 17.8667 10.6C17.4617 10.6 17.1333 10.9283 17.1333 11.3333C17.1333 11.7383 17.4617 12.0667 17.8667 12.0667ZM18.6 13.9C18.6 14.305 18.2717 14.6333 17.8667 14.6333C17.4617 14.6333 17.1333 14.305 17.1333 13.9C17.1333 13.495 17.4617 13.1667 17.8667 13.1667C18.2717 13.1667 18.6 13.495 18.6 13.9ZM19.6522 17.7143C19.6522 18.3459 19.1387 18.8572 18.5044 18.8572H5.49566C4.86129 18.8572 4.34783 18.3459 4.34783 17.7143V8.95239H19.6522V17.7143ZM18.887 4H5.11306C4.05629 4 3.20001 4.85333 3.20001 5.90476V18.0952C3.20001 19.1474 4.05629 20 5.11306 20H18.887C19.943 20 20.8 19.1474 20.8 18.0952V5.90476C20.8 4.85333 19.943 4 18.887 4Z"
        />
      </svg>
    </i>
    <div class="text">
      <span>{{ 'your-tickets' | translate }}</span>
      <span *ngIf="!wlMode">({{ count }})</span>
      <span *ngIf="wlMode" class="bm-alert-count">{{ count }}</span>
    </div>
  </button>

  <div class="popup" *ngIf="opened" (clickOutside)="toggleMenu.next(false)">
    <div class="corner"></div>
    <div class="cut-corner"></div>
    <h5 [translate]="'your-tickets'" [translateParams]="{ count: count }"></h5>
    <div class="lists-container">
      <div class="list" *ngIf="activeEvents.length > 0">
        <h6>Active</h6>
        <app-event-card
          *ngFor="let event of activeEvents"
          [itemWidth]="336"
          [forPopup]="true"
          [event]="event"
        ></app-event-card>
      </div>
      <div class="list" *ngIf="redeemedEvents.length > 0">
        <h6>Redeemed</h6>
        <app-event-card
          *ngFor="let event of redeemedEvents"
          [event]="event"
          [itemWidth]="336"
          [forPopup]="true"
        ></app-event-card>
      </div>
    </div>
  </div>
</div>
